import React from 'react'

import { novo } from '../data'
import NewItem from './NewItem'
import styled from 'styled-components'
import { mobile, hd, hdd } from '../responsive'

const Container = styled.div`
    width: 100%;
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 5%;

    ${mobile({ marginTop: "70%" })}
`

const Naslov = styled.div`
    width: 100%;
    height: 15%;
    display: flex;
    align-items: flex-end;
`

const Grid = styled.div`
    width: 90%;
    height: 85%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px,1fr));

    ${hd({ gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))" })}
    ${hdd({ gridTemplateColumns: "repeat(auto-fill, minmax(450px, 1fr))" })}
    grid-gap: 20px;
`

const New = () => {
  return (
    <Container>
        <Naslov>
            <h1 style={{marginLeft: "10%"}}>Novo</h1>
        </Naslov>
        <Grid>
            {novo.map((item) => (
                <NewItem item={item} key={item.id} />
            ))}
        </Grid>
    </Container>
  )
}

export default New